define(['angular'], function(angular) {


    /**
     * @class BoulangerieService
     */
    function BoulangerieService(userService) {
        var self = this;

        /* PACKS */

        var PACKS = [
            {
                name: 'Pack Basic',
                limit: 1,
                bonus: 0
            },
            {
                name: 'Pack Medium',
                limit: 3,
                bonus: 1
            },
            {
                name: 'Pack Premium',
                limit: 5,
                bonus: 0
            }
        ];

        self.check = {
            basic: function(pack) {
                return pack ? pack.label === PACKS[0].name : false;
            },

            medium: function(pack) {
                return pack ? pack.label === PACKS[1].name : false;
            },

            premium: function(pack) {
                return pack ? pack.label === PACKS[2].name : false;
            }
        };

        /**
         * Find pack option in a given order
         * @param  {Object} order
         * @return {Object}  option object corresponding to the pack or undefined if there is no pack present in the order
         */
        self.getPack = function getPack(order) {
            return order.options.find(function(option) {
                return option.optionType.code === 'PACK_BOULANGERIE';
            });
        };

        /* MODULES METIERS */

        /**
         * getBoulangerieModulesLimit
         * @param  {Object} orderPack
         * @return {Number} Number of modules allowed according to the pack
         */
        self.getBoulangerieModulesLimit = function getBoulangerieModulesLimit(orderPack) {
            return PACKS.find(function(pack) {
                return orderPack.label === pack.name;
            }).limit;
        };

        /**
         * getBoulangerieModulesBonus : get the amount of bonus modules allowed
         * @param  {Object} orderPack
         * @return {Number}
         */
        self.getBoulangerieModulesBonus = function getBoulangerieModulesBonus(orderPack) {
            return PACKS.find(function(pack) {
                return orderPack.label === pack.name;
            }).bonus;
        };

        self.isModuleBoulangerie = function isModuleBoulangerie(option) {
            return option.optionType.code === 'LOGICIEL_CAISSE' && option.label !== 'PRESSE';
        };

        self.resetOfferedModules = function resetOfferedModules(order) {
            order.options.filter(self.isModuleBoulangerie).forEach(function(module) {
                module.nbOffered = 0;
            });
        };

        return self;
    }

    BoulangerieService.$inject = ['userService'];

    angular.module('app.bdc.common.boulangerieService', []).factory('boulangerieService', BoulangerieService);
});
